
import state from './moduleUsersreportState'
import mutations from './moduleUsersreportMutations'
import actions from './moduleUsersreportActions'
import getters from './moduleUsersreportGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
